"use client"

import { Button, InitialsAvatar, cn } from '@yeshuman/sdk'
import type { JobProspectMatch } from '../../hooks/use-job-prospect-matches'

export type SmartAnalysisBeyondPipelineProps = {
  matches: JobProspectMatch[]
  onReviewInvite: () => void
  className?: string
}

export function SmartAnalysisBeyondPipeline({
  matches,
  onReviewInvite,
  className,
}: SmartAnalysisBeyondPipelineProps) {
  const strongMatches = matches.filter((match) => match.match_percent >= 80)

  if (strongMatches.length === 0) return null

  const avatars = strongMatches.slice(0, 3)

  return (
    <section
      aria-label="Beyond your pipeline"
      className={cn(
        'flex flex-col gap-3 rounded-lg border border-dashed border-border/80 bg-muted/20 px-4 py-3 sm:flex-row sm:items-center sm:justify-between',
        className,
      )}
    >
      <div className="flex min-w-0 items-center gap-3">
        <div className="flex -space-x-2">
          {avatars.map((match) => (
            <InitialsAvatar
              key={match.profile_id}
              src={match.avatar_url}
              colorSeed={match.profile_id}
              alt={match.name}
              className="size-8 border-2 border-background"
            />
          ))}
        </div>
        <p className="text-sm text-foreground">
          {strongMatches.length} high-estimate match
          {strongMatches.length === 1 ? '' : 'es'} are not in your pipeline.
        </p>
      </div>
      <Button type="button" variant="outline" size="sm" onClick={onReviewInvite}>
        Review in Invite
      </Button>
    </section>
  )
}
